import OneIcon from '../assets/ONE-icon.svg';
import AMPIcon from '../assets/amp_logo.svg';
import OneHubLogo from '../assets/OneHubLogo.png';

export const LOGIN_QUESTIONS = 'login-questions';
export const FORGOT_PASSWORD = 'forgot-password';
export const STANDARD_LOGIN = 'standard-login';
export const SSO_LOGIN = 'sso-login';
export const AMP = 'AMP';
export const ONE = 'ONE';
export const ONEHUB = 'ONEHUB';

export const APPETIZE_CONFIG = {
    [ONE]: {
        translateHeader: 'one_by_movista',
        headerIcon: OneIcon,
        headIconAlt: 'One by Movista',
        iconClassname: 'oneIcon',
        google: 'https://play.google.com/store/apps/details?id=com.movista.one',
        ios: 'https://apps.apple.com/us/app/one-by-movista/id954914456',
        translatedLinkText: 'launch_one',
        appToUse: ONE,
    },
    [AMP]: {
        translateHeader: 'amp_by_movista',
        headerIcon: AMPIcon,
        headIconAlt: 'AMP by Movista',
        iconClassname: 'ampIcon',
        google: 'https://play.google.com/store/apps/details?id=com.movista.mvnext',
        ios: 'https://apps.apple.com/us/app/amp-by-movista/id1603905985',
        translatedLinkText: 'launch_amp',
        appToUse: AMP,
    },
    [ONEHUB]: {
        translateHeader: 'onehub_by_movista',
        headerIcon: OneHubLogo,
        headIconAlt: '1Hub by Movista',
        iconClassname: 'oneHubIcon',
        google: 'https://play.google.com/store/apps/details?id=com.movista.crossmark',
        ios: 'https://apps.apple.com/us/app/1hub-mobile/id1436085599',
        translatedLinkText: 'launch_1hub',
        appToUse: ONEHUB,
    },
};
